import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { IconButton, Typography } from '@mui/material';
import logo from '../Reports/images/Read.png';
import { useNavigate } from 'react-router-dom';
import {
	bookIconPaperStyle,
	bookIconStyle,
	paperStyle,
	titleStyle,
} from './Pages/GeneralStyles';
import PVS from './Pages/PVS';
import CR from './Pages/CR';
import PR from './Pages/PR';
import AR from './Pages/AR';
// import BR from './Pages/BR';
import LengthStayHistory from './Pages/LengthStayHistory';

const PatientReport = () => {
	const navigate = useNavigate();

	const [PVSComponent, setPVSComponent] = useState(false);
	const [CRComponent, setCRComponent] = useState(false);
	const [PRComponent, setPRComponent] = useState(false);
	const [ARComponent, setARComponent] = useState(false);
	// const [BRComponent, setBRComponent] = useState(false);
	const [StayHistoryComponent, setStayHistoryComponent] = useState(false);

	return (
		<Box>
			{
				<Box>
					{PVSComponent ? (
						<PVS />
					) : CRComponent ? (
						<CR />
					) : PRComponent ? (
						<PR />
					) : ARComponent ? (
						<AR />
					) : // ) : BRComponent ? (
					// 	<BR />
					StayHistoryComponent ? (
						<LengthStayHistory />
					) : (
						<Paper sx={{ margin: '1rem' }} elevation={1}>
							<Box
								sx={{
									flexGrow: 1,
									height: {
										lg: '85vh',
										xs: '150vh',
									},
									padding: '15px',
								}}
							>
								<Typography style={titleStyle}> Select Report </Typography>
								<Grid
									container
									sx={{
										background: '#F6F6F6',
										borderRadius: '6px',
										padding: '15px',
									}}
								>
									<Grid
										container
										item
										spacing={2}
										columnSpacing={2}
										sx={{
											background: '#F6F6F6',
											// border: '1px solid black',
											borderRadius: '6px',
											padding: '25px',
										}}
									>
										{/* Approved Visit History */}
										<Grid item xs={12} sm={6} md={3} lg={2.4}>
											<Paper elevation={1}>
												<Box style={bookIconStyle}>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															// navigate('/Patient_Visit_Summary');
															setPVSComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														// navigate('/Patient_Visit_Summary');
														setPVSComponent(true);
													}}
												>
													<Typography>Approved Visit History</Typography>
												</Box>
											</Paper>
										</Grid>

										{/* Draft Visit History */}
										<Grid item xs={12} sm={6} md={3} lg={2.4}>
											<Paper elevation={1}>
												<Box
													sx={{
														position: 'relative',
														justifyContent: 'center',
														display: 'flex',
														top: '-30px',
														mt: {
															md: '0rem',
															sm: '0rem',
															xs: '1.5rem',
														},
													}}
												>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															// navigate('/Appointments_Report');
															setARComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														// navigate('/Appointments_Report');
														setARComponent(true);
													}}
												>
													<Typography>Draft Visit History</Typography>
												</Box>
											</Paper>
										</Grid>

										{/* Patient Report */}
										<Grid item xs={12} sm={6} md={3} lg={2.4}>
											<Paper elevation={1}>
												<Box
													sx={{
														position: 'relative',
														justifyContent: 'center',
														display: 'flex',
														top: '-30px',
														mt: {
															md: '0rem',
															xs: '1.5rem',
														},
													}}
												>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															// navigate('/Patient_Report');
															setPRComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														// navigate('/Patient_Report');
														setPRComponent(true);
													}}
												>
													<Typography>Patient Report</Typography>
												</Box>
											</Paper>
										</Grid>

										{/* Charges Report */}
										<Grid item xs={12} sm={6} md={3} lg={2.4} spacing={2}>
											<Paper elevation={1}>
												<Box
													sx={{
														position: 'relative',
														justifyContent: 'center',
														display: 'flex',
														top: '-30px',
														mt: {
															md: '0rem',
															sm: '1.5rem',
															xs: '1.5rem',
														},
													}}
												>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															// navigate('/Communication_Report');
															setCRComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														// navigate('/Communication_Report');
														setCRComponent(true);
													}}
												>
													<Typography>Charges Report</Typography>
												</Box>
											</Paper>
										</Grid>

										{/* Batches Report */}
										{/*<Grid item xs={12} sm={6} md={3} lg={2}>
											<Paper elevation={1}>
												<Box
													sx={{
														position: 'relative',
														justifyContent: 'center',
														display: 'flex',
														top: '-30px',
														mt: {
															lg: '0rem',
															xs: '1.5rem',
														},
													}}
												>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															// navigate('/Batches_Report');
															setBRComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														// navigate('/Batches_Report');
														setBRComponent(true);
													}}
												>
													<Typography>Batches Report</Typography>
												</Box>
											</Paper>
										</Grid>*/}

										{/* Length Of Stay History Report */}
										<Grid item xs={12} sm={6} md={3} lg={2.4}>
											<Paper elevation={1}>
												<Box
													sx={{
														position: 'relative',
														justifyContent: 'center',
														display: 'flex',
														top: '-30px',
														mt: {
															lg: '0rem',
															xs: '1.5rem',
														},
													}}
												>
													<Paper
														elevation={1}
														style={bookIconPaperStyle}
														onClick={() => {
															setStayHistoryComponent(true);
														}}
													>
														<Box
															component={'img'}
															src={logo}
															sx={{ width: '24.67px', height: '32.38px' }}
														></Box>
													</Paper>
												</Box>

												<Box
													style={paperStyle}
													onClick={() => {
														setStayHistoryComponent(true);
													}}
												>
													<Typography>Length of Stay History</Typography>
												</Box>
											</Paper>
										</Grid>
									</Grid>
								</Grid>
							</Box>
						</Paper>
					)}
				</Box>
			}
		</Box>
	);
};

export default PatientReport;
